
const acessoregraGridConfig = {
  idField: "idRegra",
  columns: [
    { header: "Descrição", field: "nome" },
    { header: "Tabela", field: "tabela" }
  ]
};

export default acessoregraGridConfig;

